const translatedString = (key) => ({
    key,
});

export const isTranslatedString = (obj) => {
    return obj && typeof obj.key === 'string';
};

export default translatedString;